import templateUrl from "./invite.html";
import "./invite.scss";

export const inviteComponent = {
  templateUrl,
  bindings: {
    details: "<",
  },

  controller: class Invite {
    $onInit() {
      this.showCopiedText = false;
    }
    onSuccess() {
      this.showCopiedText = true;
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/invite/invite.component.js